import React from 'react';
import { useIntl } from 'react-intl';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';

export default function OptionList(props) {
  const { currentField: { options }, setOptions } = props;
  const { formatMessage } = useIntl();

  const renderItem = (i, key) => (
    <div key={`option-${key}-${i.value}`} className="option-field" id={`option-${key}-${i.value}`}>
      <div className="available-group-name">
        <div className="group-check">
          <CheckBoxInputWithLabel
            type="text"
            name={`group-${key}-${i.name}`}
            label={formatMessage({ id: i?.nameId || i?.name || '', defaultMessage: i?.nameId || i?.name || ' ' })}
            withLabel
            addPlaceholder
            inputProps={{
              value: i.enable,
              onChange: e => setOptions(i),
            }}
          />
        </div>
      </div>
    </div>
  );
  return (
    <div className="fields-wrapper custom-scroll-theme">
      <div className="draggable-fields">
        {options.map(renderItem)}
      </div>
    </div>
  );
}
